import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface LiveCasinoIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const LiveCasinoIcon = observer(
    'LiveCasinoIcon',
    ({ className, onClick }: LiveCasinoIconPropsType): JSX.Element => {
        return (
            <SvgElement
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className={className}
                onClick={onClick}
            >
                <mask
                    id='mask0_2223_14258'
                    style={{ maskType: 'alpha' }}
                    maskUnits='userSpaceOnUse'
                    x='2'
                    y='2'
                    width='20'
                    height='20'
                >
                    <path
                        d='M15.196 8.29995L16.346 12.4499L12.796 14.8999L11.646 10.7499L15.196 8.29995ZM3.996 4.27495L3.171 4.67495C2.65433 4.89161 2.30433 5.26245 2.121 5.78745C1.93767 6.31245 1.96267 6.83328 2.196 7.34995L3.996 11.2499V4.27495ZM7.996 2.09995C7.446 2.09995 6.97517 2.29995 6.5835 2.69995C6.19183 3.09995 5.996 3.57495 5.996 4.12495V10.0999L8.671 2.74995C8.721 2.63328 8.76267 2.52078 8.796 2.41245C8.82933 2.30411 8.88767 2.19995 8.971 2.09995H7.996ZM13.146 2.22495C12.6293 2.04161 12.1127 2.06661 11.596 2.29995C11.0793 2.53328 10.7293 2.90828 10.546 3.42495L6.121 15.6499C5.93767 16.1666 5.96267 16.6791 6.196 17.1874C6.42933 17.6958 6.80433 18.0416 7.321 18.2249L14.846 20.9749C15.3627 21.1583 15.8752 21.1333 16.3835 20.8999C16.8918 20.6666 17.2377 20.2916 17.421 19.7749L21.871 7.54995C22.0543 7.03328 22.0293 6.52078 21.796 6.01245C21.5627 5.50411 21.1877 5.15828 20.671 4.97495L13.146 2.22495Z'
                        fill='#fill'
                    />
                </mask>
                <g mask='url(#mask0_2223_14258)'>
                    <rect
                        width='24'
                        height='24'
                        fill='fill'
                        fillOpacity='0.64'
                    />
                </g>
            </SvgElement>
        );
    }
);
